import React, { useEffect } from "react";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import InputAHSF from "../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetApplicationInfo } from "../../../Redux/Reducers/Manager/ApplicationInformation";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { useNavigate } from "react-router-dom";
import { encryptToken } from "../../../Services/Encryption/EncryptionParams";

function ApplicationInformation(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => {
    return {
      ApplicationInfo: state.ApplicationInfo.ApplicationInfo,
      ApplicationInformation:
        state.ApplicationInformationReducer.ApplicationInformation,
    };
  });

  useEffect(() => {
    dispatch(GetApplicationInfo(props.applicationGuid));
  }, [props.applicationGuid]);

  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName="معلومات الطلب"
        child={[
          <div className="form-grid" key="info-grid">
            <InputAHSF
              fieldsName="FullName"
              show={true}
              disabled={true}
              value={state.ApplicationInfo?.applicantName}
            />
            <InputAHSF
              fieldsName="Gender"
              show={true}
              disabled={true}
              value={state.ApplicationInfo?.gender ? "ذكر" : "انثى"}
            />
            <InputAHSF
              fieldsName="Nationality"
              show={true}
              disabled={true}
              value={state.ApplicationInfo?.nationalityName}
            />
            <InputAHSF
              fieldsName="Sector"
              show={true}
              disabled={true}
              value={state.ApplicationInfo?.sectorName}
            />
            <InputAHSF
              fieldsName="NameOfTnstitution"
              show={true}
              disabled={true}
              value={state.ApplicationInfo?.foundationName!=null?state.ApplicationInfo?.foundationName:state.ApplicationInfo?.otherFoundationName}
            />
            <InputAHSF
              fieldsName="DepartmentCircle"
              show={true}
              disabled={true}
              value={state.ApplicationInfo?.department}
            />
          </div>,
        ]}
        showButton={true}
        id_Title="withBtnTitle"
        buttonComponent={
          // Display a button to show the budget summary
          <ButtonAHSF
            id={"btnTitle"}
            type={"submitter"}
            onClick={() => {
             let token = encryptToken(props.applicationGuid);
                     window.open(
                       `/SRFund/manager/MainResearcherInformainContainer/` + token,
                       "_blank"
                     );
            }}
            disabled={false}
            title={"عرض الطلب"}
            text={"عرض الطلب"}
            show={true}
          />
        }
      />
    </>
  );
}

export default ApplicationInformation;
